'use client'

import { useState, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const logosBase = '/images/logos'
const LOGOS: Record<string, { logoWhite: string; logoBlack: string }> = {
  gearsOfWar: {
    logoWhite: `${logosBase}/gearsOfWar-white.svg`,
    logoBlack: `${logosBase}/gearsOfWar.svg`
  },
  gearsOfWarFull: {
    logoWhite: `${logosBase}/gearsOfWar-full-white.svg`,
    logoBlack: `${logosBase}/gearsOfWar-full.svg`
  },
  gearsOfWarNoOmen: {
    logoWhite: `${logosBase}/gearsOfWar-vertical-no-omen-white.svg`,
    logoBlack: `${logosBase}/gearsOfWar-vertical-no-omen-black.svg`
  },
  theCoalition: {
    logoWhite: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/theCoalition-white-5f2b1be4bddeb-6705aa9b6d1ed.svg',
    logoBlack: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/theCoalition-5f2b1be957e4c-6705aa98714dc.svg'
  },
  theCoalitionFull: {
    logoWhite: `${logosBase}/theCoalition-full-white.svg`,
    logoBlack: `${logosBase}/theCoalition-full.svg`
  },
  xboxGameStudios: {
    logoWhite: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/XboxGameStudios_2020_hrz_Wht-5f2b1addc7aa9-6705aa94c2dff.svg',
    logoBlack: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/XboxGameStudios_2020_hrz_Grn-5f2b1ad431c06-6705aa9e3c657.svg'
  },
  xboxLive: {
    logoWhite: `${logosBase}/xboxLive-white.svg`,
    logoBlack: `${logosBase}/xboxLive.svg`
  },
  matureContent: {
    logoWhite: `https://dev.cdn.gearsofwar.com/gearsofwar/sites/3/2026/02/esrb-m-content-699764e407881.svg`,
    logoBlack: `https://dev.cdn.gearsofwar.com/gearsofwar/sites/3/2026/02/esrb-m-content-699764e407881.svg`
  }
}

interface UseLogoOptions {
  enableContrast?: boolean
}

const DEFAULT_OPTIONS: UseLogoOptions = {
  enableContrast: true
}

const useLogo = (name: string = 'gearsOfWarFull', options: UseLogoOptions = DEFAULT_OPTIONS) => {
  const theme = useTheme()
  const _options = { ...DEFAULT_OPTIONS, ...options }

  // Dark theme → default to white logo
  const defaultLogo = LOGOS[name].logoWhite
  const [logo, setLogo] = useState(defaultLogo)

  const isHighContrast = useMediaQuery(theme.accessibility.highContrast.mediaQuery('active'))

  useEffect(() => {
    if (_options.enableContrast && isHighContrast) {
      // Light high contrast (black text on white bg) → use black logo
      setLogo(LOGOS[name].logoBlack)
    } else {
      setLogo(LOGOS[name].logoWhite)
    }
  }, [isHighContrast, _options.enableContrast, name])

  return logo
}

export default useLogo
